import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Select from 'react-select';
import { format } from "date-fns";
import NonprofitTile from '../../../components/NonprofitTile';
import FilterByInput from '../../../components/FilterByInput';
import * as adminNonprofit10BdBeListActions from '../../../reducers/Admin/admin10BdBeListReducer';
import { OverlayTrigger, Form, Popover, Button, Row, Col } from "react-bootstrap";
import { isMobile } from "react-device-detect";
import '../AdminNonprofitList/AdminNonprofitList.scss';
import Loading from '../../../appComponents/Loading';
import Helpers from '../../../utils/helpers';
import Pagination from '../../../components/Pagination/Pagination';
import { financialYears } from '../../../utils/helpers';
import { asyncDownloadFile } from '../../../utils/helpers';
const tableHeading = [
  "Name of the NGO",
  "NGO ID",
  "NGO PAN",
  "Total 10BD Amount",
  'Total 10BD Certificates',
  "Total 10BE Amount Received",
  "Total 10BE Certificate Received",
  "Total 10BE Amount Matched",
  "Total 10BE Certificates Matched",
  "Details",
];

const fy = financialYears();
let financialYear = [fy]

class Admin10BeBdNonprofits extends Component {
  constructor(props) {
    super(props);
    this.state = {
      query: {},
      reportLinks: [],
      loader: false,
      ngoDataLoader: false,
      isAllItemsSelected:false,
      onNonProfitsSelected : [],
      downloadLoader: false,
      filters: [
        {
          label: 'Search',
          type: [{
            type: 'default',
            label: 'Nonprofit Name',
            query: 'q',
          },
          {
            type: "nonprofitID",
            "label" : "Nonprofit ID",
            "query" : "filter_by_nonprofit_id"
          },
          {
            type: 'pan',
            label: 'PAN Number',
            query: 'filter_by_pan',
          },
        ],
          placeholder: 'Search for NonProfit Name, ID, PAN',
        }
      ],
      fYears: [
        { value: 'fy2024-2025', label: 'FY 2024-2025' }
      ],
      nonProfitsList:[],
      selectedIDS : []
    };
  }

  componentDidMount() {
    const filters = [
      {
        "label": "Search",
        "type": [
          {
            "type": "default",
            "label": "Nonprofit Name",
            "query": "q"
          },
          {
            type: "nonprofitID",
            "label" : "Nonprofit ID",
            "query" : "filter_by_nonprofit_id"
          },
          {
            type: 'pan',
            label: 'PAN Number',
            query: 'filter_by_pan',
          },
        ],
        "placeholder": "Search for NonProfit Name, ID, PAN"
      },
    ]
    this.setState({ filters, query: Helpers.queryBuilderForFilterInput(filters) }, () => {
      this.refreshNonprofitList();
    });
  }
 
  retrieveCheckedItems = (ngos) => {
    const formattedData = ngos.map((ngosData) => ({ nonprofitId: ngosData._id }));
    this.setState({ onNonProfitsSelected : formattedData }); 
  };

  handleOnAllItemsSelected = (value) => {
    this.setState({ isAllItemsSelected : value})
  }

  componentWillUnmount() {
    const { Nonprofits } = this.props;
    Nonprofits.reset();
  }

  filterOnChange = (filters) => {
    this.setState({ filters, query: Helpers.queryBuilderForFilterInput(filters),nonProfitsList:[] }, () => {
      this.refreshNonprofitList();
    });
  }

  refreshNonprofitList = () => {
    const { Nonprofits } = this.props;
    const { query, ngoDataLoader } = this.state;
    const searchQuery = { ...query }
    this.setState({
      ngoDataLoader: true
    })
    Nonprofits.reset();
    Nonprofits.getNonprofits(searchQuery).then(()=>{
    const { nonprofits } = this.props;
    this.setState({ nonProfitsList: nonprofits?.nonprofits10BdBe, ngoDataLoader: false });
    })
  }

  loadMore = () => {
    const { Nonprofits } = this.props;
    const { query } = this.state;
    this.setState({
      ngoDataLoader : true
    })
    Nonprofits.getNonprofits(query).then(()=>{
      const { nonprofits } = this.props;
      this.setState({ nonProfitsList: nonprofits?.nonprofits10BdBe, ngoDataLoader : false });
    })
  }

  NonprofitListHTML = () => {
    const { nonprofits } = this.props;
    const { query,nonProfitsList } = this.state;
    if (!nonprofits.get_status.nonprofit || (nonprofits.get_status.nonprofit === 'pending' && nonprofits.nonprofits?.nonprofits10BdBe?.length === 0)) {
      return (<Loading />);
    }
    // use this on table if no data is der in pagination
    // if (nonProfitsList?.length === 0) {
    //   return (
    //     <i className="align-center">No items available</i>
    //   );
    // }
    const handleApprove = async (status) => {
      const { Nonprofits } = this.props;
      await Nonprofits.reset()
      await Nonprofits.getNonprofits({ status }).then((res)=>{
        this.setState({ nonProfitsList: res.data },()=>{
          this.NonprofitListHTML()
        });
      });
     
    }
    return nonProfitsList.map(item => (
      <div className="col-xl-3 col-lg-3 col-md-6 col-12 ngo-list-col" key={item.slug}>
        <NonprofitTile value={item} link={'/admin/10bdbe/'} is10BdBe query={query} handleApprove={handleApprove} />
      </div>
    ));
    
  }


  getReportLinks = (e, isExport) => {
    e.preventDefault();
    const { Nonprofits } = this.props;
    this.setState({
      loader: true
    })
    if (isExport) {
      this.setState({
        currentTab: isExport
      })
    }

    const query = {
      is10BdBe: true,
    }

    Nonprofits.getReportLinks(query).then((data) => {
      setTimeout(() => {
        this.setState({
          loader: false
        })
      }, 2000);
      this.setState({ reportLinks: data });
    });
  };

  popover = () => {
    const { nonprofits } = this.props;
    const { reportLinks } = this.state;

    return (
      <Popover id="popover-basic-1">
        <Popover.Content>
          <Row>
            <Col md={12} xs={12} className="export-download">
              <ul className="nav nav-tabs tab-basic" role="tablist">
                <li className="nav-item">
                  <a className={`${`nav-link ${this.state.currentTab === 'export' ? `active` : ''} show`}`} id="export-tab" data-toggle="tab" href="#export" onClick={(e) => this.onTabChange(e, 'export')} >Export</a>
                </li>
                <li className="nav-item">
                  <a className={`${`nav-link ${this.state.currentTab === 'downloads' ? `active` : ''} show`}`} id="download-tab" data-toggle="tab" href="#download" onClick={(e) => this.onTabChange(e, 'downloads')} >Downloads</a>
                </li>
              </ul>
              <div className="tab-content tab-content-basic">
                {
                  this.state.currentTab === 'export' ?
                    <div className="tab-pane fade show active">
                      <Col md={12} xs={12} className="export-filters">
                        <Popover.Title as="h3">Select Fields</Popover.Title>
                        <Form.Check className="popover-checkbox" type="checkbox" id="basic" label="Basic Details" disabled checked />
                        {/* <div className="popover-checkbox-div" htmlFor="basic">{fieldNames && fieldNames?.basic}</div> */}

                        <div className="text-center">
                          <Button className="btn btn-sm" onClick={this.generateReportLink} 
                            disabled={Object.values(this.state.onNonProfitsSelected).length > 10 || !Object.values(this.state.onNonProfitsSelected).length > 0}
                          >
                            {nonprofits.get_status.generate_report === '' ? 'Export to CSV' : nonprofits.get_status.generate_report === 'pending' ? 'Generating...' : 'Export to CSV'}
                            </Button>
                        </div>
                      </Col>
                    </div> :
                    <div className="tab-pane fade show active" style={{maxHeight:"400px", overflowY :"auto", display:"block", whiteSpace:"nowrap"}}>
                      <Col md={12} xs={12}>
                        <Popover.Title as="h3">
                          <span>Queued for download</span>
                          <button type="button" className="btn btn-inverse-link" onClick={this.getReportLinks}>
                            <div className="export">
                              <div className={`${this.state.loader ? `export-loader-spin` : `export-loader`}`}></div>
                            </div>
                          </button>
                        </Popover.Title>
                        <table className="table">
                          <thead>
                            <tr>
                              <th>Requested</th>
                              <th>Tags</th>
                              <th>Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            {(!reportLinks || reportLinks?.length === 0) &&
                              <i className="align-center">No items available</i>}
                            {reportLinks && reportLinks?.length && reportLinks.map((link, index) => {
                              console.log(reportLinks ,'re')
                              // let filterAppl = link.queryParameter.filter;
                              let filterId = link.nonprofit_id;
                              let filterNGOname = link.nonprofit_name
                              return (
                                <tr key={index}>
                                  <td style={{ maxWidth: "100%", whiteSpace: "nowrap" }}>
                                    <div className="download-tag-wrapper">
                                      <span className="download-tag">{format(new Date(link.created_at), "MMM do, yyyy HH:mm aa")}</span>
                                    </div>
                                  </td>
                                  <td>
                                    <div className="download-tag-wrapper">
                                      {['a'].map(item => (
                                        <>
                                          {
                                            filterId &&
                                            <>
                                            {filterId ? <span className="download-tag">{filterId}</span> : ''}
                                            {/* {filterNGOname ? <span className="download-tag">Ngo:{filterNGOname}</span> : ''} */}
                                            </>
                                          }
                                        </>
                                      ))}
                                    </div>
                                  </td>
                                <td>
                                <p
                                  className={`btn btn-xs ${link?.status === 'active' ? 'btn-success' : 'disabled btn-secondary'}`}
                                  onClick={() => this.handleDownload(link.file_uri, `${link?.nonprofit_slug}__${link?.nonprofit_pan_card}`)}
                                  >
                                  {link?.status === 'active' ? 'Download' : link.status}
                                </p>
                                </td>
                                  {/* <td><a className={`btn btn-xs ${link.status === 'active' ? 'btn-success' : 'disabled btn-secondary'}`} href={link.file_uri} download={`GiveFundraisers-live-${format(new Date(), 'HH:mm:ss')}`}>
                                    {link.status === 'active' ? 'Download' : link.status}
                                    </a></td> */}
                                </tr>
                              )
                            })}
                          </tbody>
                        </table>
                      </Col>
                    </div>}
              </div>
            </Col>
          </Row>
          <Row></Row>
        </Popover.Content>
      </Popover>
    );
  };

  generateReportLink = (e) => {
    e.preventDefault();
    this.setState({ loader: true })
    const { Nonprofits, match } = this.props;
    const { state } = this.props.location
    const { id, nonprofit } = match.params;
    const nonprofitId = (state?.nonprofit ? state.nonprofit : id) || state || nonprofit
    const params = Object.values(this.state.onNonProfitsSelected);
    // const nonprofitIds = this.state.onNonProfitsSelected;
    const isAllItemsSelected = this.state.isAllItemsSelected;
    Nonprofits.generateReportLink10BdBe(isAllItemsSelected ? [] : params)?.then((data) => {
      if (data !== undefined) {
        // const { match } = this.props
        // const { state } = this.props.location
        // const { nonprofit } = match.params;

        // const nonprofitId = state?.nonprofit ? state.nonprofit : nonprofit
        // const isAdmin = state?.nonprofit?.name && state?.nonprofit?.name.length > 0;
        const query = {
          is10BdBe: true,
          // nonprofitId: isAdmin ? nonprofitId : undefined
        }

        Nonprofits.getReportLinks(query).then((reportsData) => {
          this.setState({ reportLinks: reportsData, currentTab: 'downloads', loader: false });
        });
      }
      else {
        this.setState({ currentTab: 'export', loader: false });
      }
    });
  };
  
  onTabChange = (e, tab) => {
    this.setState({
      currentTab: tab
    })
    if (tab === 'downloads') {
      this.getReportLinks(e, 'downloads')
    }
  };

handleDownload = async (url, nameConvention) => {
  this.setState({ downloadLoader: true })
  try {
    await asyncDownloadFile(url, nameConvention);
  } catch (error) {
    console.log(error);
  } finally {
    this.setState({ downloadLoader: false })
  }
};

  render() {
    const { nonprofits } = this.props;
    const { nonprofit_count } = nonprofits || ''
    const { filters, query } = this.state;
    const isValidLength = nonprofits?.nonprofits10BdBe && nonprofits?.nonprofits10BdBe.length !== 0 && nonprofits?.nonprofits10BdBe.length % 10 === 0;
    const { status } = query || ''
    return (
      <div className="content-wrapper">
        <div className="row">
          <div className="col-12 grid-margin">
            <div className="card">
              <div className="card-body">
                <div className="row">
                  <h3 className="mr-b-20">10BD/BE</h3>
                  <div className="col-md-3">
                    <Select isMulti={false} defaultValue={financialYear[0]} isDisabled />
                  </div>
                </div>
                <FilterByInput nonProfitCount={nonprofit_count} value={filters} onChange={this.filterOnChange} isOnlySearch={status === 'downloaded'} is10BE={true} />
                <div className="row justify-content-end">
                  <div className="col-md-12 col-12 text-right">
                    <OverlayTrigger
                      trigger="click"
                      placement={isMobile ? "bottom-end" : "left-start"}
                      overlay={this.popover()}
                      rootClose
                    >
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={(e) => this.getReportLinks(e, "export")}
                      >
                        Export 10BD
                      </button>
                    </OverlayTrigger>
                    <div>
                      <i>
                        <small className="text-muted">Max 10 NGOs 10BD files can be exported at a time</small>
                      </i>
                    </div>
                  </div>
                </div>
                {/* {Object.keys(query).length === 0 &&
                  <button disabled={(status === 'downloaded' || status === '') || !status} type="button" className="btn btn-outline-primary btn-rounded btn-fw mr-3 mt-3"
                  >Status: Downloaded</button>

                }
                <div className="row ngo-list-wrapper">
                  {this.NonprofitListHTML()}
                </div> */}
                {/* <div className="row">
                  {(isValidLength) ? (
                    <div className="col-md-12 text-center">
                      <button type="button" className="btn btn-fw align-center" onClick={(e) => { e.preventDefault(); this.loadMore(); }}>Load more</button>
                    </div>
                  ) : null}
                  {(nonprofits.get_status.nonprofit === 'pending' && nonprofits.nonprofits?.nonprofits10BdBe.length !== 0) ? (
                    <div className="col-md-12 d-flex">
                      <Loading />
                    </div>
                  ) : null}
                </div> */}
              </div>
            </div>
            <Pagination 
              handleOnAllItemsSelected={this.handleOnAllItemsSelected}
              retrieveCheckedItems={this.retrieveCheckedItems} 
              tableHeading={tableHeading} 
              lists={this.state.nonProfitsList} 
              onNonProfitsSelected={this.state.onNonProfitsSelected} 
              count={nonprofit_count} 
              loadMore={this.loadMore} 
              typeOfTable={"NGO_TABLE"} 
              viewDetailsLink={"/10bdbe/uploads/"}
              query={this.state.query}

              loader={this.state.ngoDataLoader}
              />
          </div>

        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  nonprofits: state.adminNonprofit10BdBeList
});

const mapActionToProps = dispatch => ({
  Nonprofits: bindActionCreators(adminNonprofit10BdBeListActions, dispatch),
});

export default connect(
  mapStateToProps,
  mapActionToProps,
)(Admin10BeBdNonprofits);
